module.exports = __webpack_public_path__ + "assets/images/project/russia-desktop.jpg?v=4536f603";